import { DocumentStatusGroupingResource } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentStatusGrouping = async (
  constructGet: ConstructGet,
  documentParams: DocumentParams,
  documentId: string,
  groupingKey: string,
): Promise<NonPaginatedResponse<DocumentStatusGroupingResource> | undefined> =>
  constructGet<NonPaginatedResponse<DocumentStatusGroupingResource>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/status/${documentParams.definition}/grouping/${groupingKey}`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
  );
